import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { popNext } from "@/lib/draft";
import { useAuth } from "@/context/AppContext";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sid });
        setUser(data);
        const next = popNext() || "/minhas-solicitacoes";
        window.history.replaceState(null, "", window.location.pathname);
        nav(next, { replace: true });
      } catch (e) {
        setErr(errMsg(e));
        window.history.replaceState(null, "", "/entrar");
        setTimeout(() => nav("/entrar", { replace: true }), 2500);
      }
    })();
  }, [location.hash, nav, setUser]);

  return err ? <p className="p-10 text-center text-red-700" data-testid="auth-callback-error">{err}</p> : null;
}
